import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta';
import { useT } from '../i18n/useT';
import RouteHero from '../components/RouteHero';
import ConnectorsSection from '../components/ConnectorsSection';
import ConnectData from '../components/ConnectData';
import ConnectivityGuide from '../components/ConnectivityGuide';
import BackToOverview from '../components/BackToOverview';

const ConnectorsPage: React.FC = () => {
  useRouteMeta('connectors');
  const { r } = useT();
  return (
    <>
      <RouteHero
        eyebrow={r.routes.connectors.eyebrow}
        title={r.routes.connectors.heroTitle}
        subtitle={r.routes.connectors.heroSubtitle}
      />
      <ConnectorsSection />
      <ConnectData />
      <ConnectivityGuide />
      <BackToOverview />
    </>
  );
};

export default ConnectorsPage;
